import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import { bem } from 'helpers/class-name';
import LINKS from 'constants/links';
import { reactHookFormPropTypes } from 'constants/propTypes';
import { ILLUSTRATIONS } from 'constants/icons';
import SmartSpotOnboarding from './SmartSpotOnboarding';
import { messages as releaseExtraSpotsMessages } from './ReleaseExtraSpots';
import { messages as peakTimeMessages } from './PeakTimeDefinition';
import { getPeakTimeMessage } from './SmartTools.helpers';
import RemainingItem from './RemainingItem';

const messages = defineMessages({
  nextButton: {
    id: 'smart-spot-onboarding.release-extra-spots.next-button',
    defaultMessage: 'Next',
  },
});

const { element } = bem('smart-spot-onboarding-release-extra-spots');

const SmartSpotOnboardingReleaseExtraSpots = ({
  control,
  countryCode = 'USA',
  handleLearnMore,
  onSkip,
  onNext,
  isSubmitting = false,
  isNextDisabled = false,
  showSelectOptionPeakTime = true,
  showSelectOptionOffPeakTime = true,
}) => {
  const peakTimeMessage = getPeakTimeMessage(countryCode, peakTimeMessages);

  return (
    <SmartSpotOnboarding
      title={releaseExtraSpotsMessages.title}
      description={releaseExtraSpotsMessages.description}
      settingDetail={releaseExtraSpotsMessages.settingDetail}
      countryCode={countryCode}
      learnMoreLink={LINKS.smartspot.learnMore}
      handleLearnMore={handleLearnMore}
      learnMoreLocation="release_extra"
      illustration={ILLUSTRATIONS.exerciseBikes}
      showLearnMorePeakTimes
      nextButton={messages.nextButton}
      onSkip={onSkip}
      onNext={onNext}
      isSubmitting={isSubmitting}
      nextButtonDisabled={isNextDisabled}>
      <div className={element('content-group')}>
        <RemainingItem
          className={element('remaining-item')}
          control={control}
          label={releaseExtraSpotsMessages.peak}
          info={releaseExtraSpotsMessages.peakInfo}
          schedule={peakTimeMessage}
          remainingName="releaseExtraSpotsPeakTime"
          showSelectOption={showSelectOptionPeakTime}
        />
        <RemainingItem
          className={element('remaining-item')}
          control={control}
          label={releaseExtraSpotsMessages.offPeak}
          info={releaseExtraSpotsMessages.offPeakInfo}
          schedule={peakTimeMessages.offPeakTime}
          remainingName="releaseExtraSpotsOffPeakTime"
          showSelectOption={showSelectOptionOffPeakTime}
        />
      </div>
    </SmartSpotOnboarding>
  );
};

SmartSpotOnboardingReleaseExtraSpots.propTypes = {
  control: reactHookFormPropTypes.control.isRequired,
  countryCode: PropTypes.string,
  handleLearnMore: PropTypes.func.isRequired,
  onSkip: PropTypes.func,
  onNext: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isNextDisabled: PropTypes.bool,
  showSelectOptionPeakTime: PropTypes.bool,
  showSelectOptionOffPeakTime: PropTypes.bool,
};

export default SmartSpotOnboardingReleaseExtraSpots;
